import { render } from "./ShippingRestrictionsComponent.vue?vue&type=template&id=4647e8c2"
const script = {}

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__